import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Error404 from '../components/common/Alert/Error404';
import AdminRoutes from '../components/projects/Admin/Routers/AdminRoutes';

export default function MainRouter() {
  return (
    <>
      <Routes>
          <Route path='/av-admin/*' exact element={<AdminRoutes />} />
          <Route path='*' element={<Error404 />} />
      </Routes>
    </>
  )
}
